<cvc-form-buttons>
  <button
    type="submit"
    nz-button
    nzType="primary"
    [disabled]="!form.valid"
    nzSize="large">
    {{ props.submitLabel }}
  </button>
</cvc-form-buttons>
